import React from 'react';
import { getInitialPermissionLevelContext } from 'utils/permission.utils';

export interface IPermissionLevelContext {
  LEVEL_ROLE_VIEW: boolean;
  LEVEL_ROLE_CREATE: boolean;
  LEVEL_ROLE_EDIT: boolean;
  LEVEL_ROLE_CHANGE_STATUS: boolean;
  LEVEL_POLICY_VIEW: boolean;
  LEVEL_POLICY_CREATE: boolean;
  LEVEL_POLICY_EDIT: boolean;
  LEVEL_POLICY_CHANGE_STATUS: boolean;
  LEVEL_HELP_INFORMATION_VIEW: boolean;
  LEVEL_HELP_INFORMATION_CREATE: boolean;
  LEVEL_HELP_INFORMATION_EDIT: boolean;
  LEVEL_HELP_INFORMATION_CHANGE_STATUS: boolean;
  LEVEL_SIGN_IN_AS_SUPPORT_USER: boolean;
  LEVEL_TRANSFER_OWNERSHIP: boolean;
  LEVEL_GENERAL_INFO_VIEW: boolean;
  LEVEL_GENERAL_INFO_EDIT: boolean;
  LEVEL_BANK_INFO_VIEW: boolean;
  LEVEL_BANK_INFO_EDIT: boolean;
  LEVEL_BILLING_INFO_VIEW: boolean;
  LEVEL_BILLING_INFO_EDIT: boolean;
  LEVEL_FEE_RATES_VIEW: boolean;
  LEVEL_FEE_RATES_EDIT: boolean;
  LEVEL_PROCESSOR_CONFIG_VIEW: boolean;
  LEVEL_PROCESSOR_CONFIG_EDIT: boolean;
  LEVEL_TAXES_INFO_VIEW: boolean;
  LEVEL_TAXES_INFO_EDIT: boolean;
  LEVEL_OTHER_INFO_VIEW: boolean;
  LEVEL_OTHER_INFO_EDIT: boolean;
  LEVEL_REQUIRED_FIELDS_VIEW: boolean;
  LEVEL_REQUIRED_FIELDS_EDIT: boolean;
  LEVEL_PAY_PERIOD_SETTINGS_VIEW: boolean;
  LEVEL_PAY_PERIOD_SETTINGS_CREATE: boolean;
  LEVEL_PAY_PERIOD_SETTINGS_EDIT: boolean;
  LEVEL_PAY_PERIOD_VIEW: boolean;
  LEVEL_PAY_PERIOD_EDIT: boolean;
  LEVEL_PAY_PERIOD_CHANGE_STATUS: boolean;
  LEVEL_INTEGRATION_VIEW: boolean;
  LEVEL_INTEGRATION_EDIT: boolean;
  LEVEL_INTEGRATION_CHANGE_STATUS: boolean;
  LEVEL_EMPLOYEE_EDIT: boolean;
  LEVEL_EMPLOYEE_CHANGE_STATUS: boolean;
}

const PermissionLevelContext = React.createContext<IPermissionLevelContext>(
  getInitialPermissionLevelContext(),
);

export default PermissionLevelContext;
